import styled from "styled-components";

export const Primary = styled.div`
	${({ theme }) => theme.textStyles.primary};
`;

export const PrimaryMedium = styled.div`
	${({ theme }) => theme.textStyles.primaryMedium};
`;

export const PrimaryBold = styled.div`
	${({ theme }) => theme.textStyles.primaryBold};
`;

export const Small = styled.div`
	${({ theme }) => theme.textStyles.small}
`;
